export enum ThumbnailType {
  STRIP = 'strip',
  CUSTOM = 'custom',
}
